import Header from './src/components/header/Header'
import Footer from './src/components/footer/Footer'
import "./TermCondition.css";
import TCListItem from "./TCListItem";

const TermCondition = () => {
    return (
        <>
        <Header/>
         <div className="container terms-page">
      <div className="row">
        <div className="col-md-12">
          <div className="terms-container">
            {/* Header Section */}
            <div className="terms-header-section">
              <h1 className="terms-main-title">
                TERMS AND CONDITIONS
                <span className="company-subtitle">
                 Event Planet Technologies India Private Limited
                </span>
              </h1>
              <div className="last-updated">
                Last Updated: December 29, 2025
              </div>
            </div>

            {/* Legal Notice */}
            <div className="legal-notice">
              <div className="legal-icon">⚖️</div>
              <p>
                THIS USER TERMS AND CONDITIONS IS AN ELECTRONIC RECORD IN THE
                FORM OF AN ELECTRONIC CONTRACT FORMED UNDER THE INFORMATION
                TECHNOLOGY ACT, 2000 AND THE RULES MADE THEREUNDER AND THE
                AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS
                IN VARIOUS STATUTES AS AMENDED BY THE INFORMATION TECHNOLOGY
                ACT, 2000. THIS DOCUMENT DOES NOT REQUIRE ANY PHYSICAL,
                ELECTRONIC OR DIGITAL SIGNATURE. THIS ELECTRONIC RECORD IS
                PUBLISHED IN COMPLIANCE WITH RULE 3(1) OF THE INFORMATION
                TECHNOLOGY (INTERMEDIARIES GUIDELINES AND DIGITAL MEDIA ETHICS
                CODE) RULES, 2021.
              </p>
            </div>

            {/* Part A Header */}
            <div className="section-divider">
              <h2 className="part-title">PART A</h2>
              <div className="divider-line"></div>
            </div>

            {/* Introduction Section */}
            <div className="content-section">
              <div className="section-header">
                <span className="section-icon">📋</span>
                <h3>INTRODUCTION</h3>
              </div>

              <div className="company-intro">
                <div className="intro-card">
                  <div className="intro-icon">🏢</div>
                  <div>
                    <p>
                      <strong>
                        Event Planet Technologies India Private Limited
                      </strong>
                      (hereinafter referred to as
                      <strong>"Event Planet"</strong>) is a company engaged in
                      the business of providing end-to-end solutions for wedding
                      planning, events, exhibitions, conventions and trade shows
                      organisation by connecting Users with vendors and venues
                      based on their specific requirements and budget.
                    </p>
                  </div>
                </div>
              </div>

              <div className="important-note">
                <div className="note-icon">⚠️</div>
                <p>
                  These User terms and conditions provides for the legal rights
                  and responsibilities with respect to the access and use of
                  website, mobile site and app (hereinafter referred to as "
                  <strong>Platform</strong>").
                </p>
              </div>

              <div className="terms-highlights">
                <div className="highlight-item">
                  <span className="highlight-number">1</span>
                  <p>
                    These User terms and conditions (hereinafter referred as "
                    <strong>Terms of Use</strong>") and amended provisions from
                    time to time govern your access and use of Event Planet's
                    Platform.
                  </p>
                </div>
                <div className="highlight-item">
                  <span className="highlight-number">2</span>
                  <p>
                    Before using, interacting or procuring the services
                    (hereinafter referred to as <strong>"Services"</strong>) of
                    Platform, the Users shall compulsorily read and understand
                    this Terms of Use and by transacting on the Platform shall
                    be deemed to have accepted this Terms of Use as a binding
                    document which governs user's dealings and transactions with
                    Event Planet.
                  </p>
                </div>
                <div className="highlight-item">
                  <span className="highlight-number">3</span>
                  <p>
                    You can accept the Terms of Use by clicking to accept or
                    agree to the Terms of Use, where it is made available to you
                    by Event Planet in the User interface. In this case, you
                    understand and agree that Event Planet will treat your use
                    of the Services as acceptance of the Terms of Use from that
                    point onwards.
                  </p>
                </div>
                <div className="highlight-item">
                  <span className="highlight-number">4</span>
                  <p>
                    All rights and liabilities of the Event Planet and user with
                    respect to any Services facilitated by Event Planet shall be
                    restricted to the scope of this Terms of Use and any
                    supplementary terms governing particular Services, notices,
                    disclaimers, policies, and guidelines, as applicable and are
                    deemed to be part of this Terms of Use.
                  </p>
                </div>
                <div className="highlight-item">
                  <span className="highlight-number">5</span>
                  <p>
                    User may not use the Platform if unable to accept the Terms
                    of Use or are unable to be bound by the it.
                  </p>
                </div>
              </div>
            </div>

            {/* APPLICABILITY */}
            <div className="content-section">
              <div className="section-header">
                <span className="section-icon">🎯</span>
                <h3>APPLICABILITY</h3>
              </div>

              <div className="numbered-list">
                <div className="list-item">
                  <div className="item-number">1</div>
                  <div className="item-content">
                    For the purposes of this Terms of Use wherever the context
                    so requires, User/ Users shall mean any natural or legal
                    person who accesses or uses the Platform for the purpose of
                    browsing, selecting, purchasing or availing event-related
                    services, packages, or any other offerings provided through
                    the Platform.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">2</div>
                  <div className="item-content">
                    For the purpose of this Terms of Use wherever the context so
                    requires "you/You" or "your/Your" shall mean User and the
                    term "We", "us/Us", "our/Our" shall mean Event Planet.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">3</div>
                  <div className="item-content">
                    Both User and Event Planet are individually referred to as
                    'Party' and collectively referred to as 'Parties' to this
                    Terms of Use.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">4</div>
                  <div className="item-content">
                    Certain Services offered on the Platform may be subject to
                    additional or supplementary terms and conditions ("
                    <strong>Supplementary Terms</strong>") which are
                    incorporated into this Terms of Use by reference. In the
                    event of an inconsistency between this Terms of Use and
                    Supplementary Terms, the provisions of the Supplementary
                    Terms shall control to the extent of conflict. The User
                    should refer to the relevant Supplementary Terms applicable
                    for the given Services as ordered by the User.
                  </div>
                </div>
              </div>
            </div>

            {/* ELIGIBILITY */}
            <div className="content-section">
              <div className="section-header">
                <span className="section-icon">✅</span>
                <h3>ELIGIBILITY</h3>
              </div>

              <div className="eligibility-cards">
                <div className="eligibility-card">
                  <div className="eligibility-icon">📝</div>
                  <div className="eligibility-content">
                    <h4>Legal Capacity</h4>
                    <p>
                      User must be eligible to enter into legally binding
                      contract as per the Indian Contract Act, 1872 and hall be
                      eligible to access, register on, and transact through the
                      Platform.
                    </p>
                  </div>
                </div>
                <div className="eligibility-card">
                  <div className="eligibility-icon">🔞</div>
                  <div className="eligibility-content">
                    <h4>Age Requirement</h4>
                    <p>
                      If you are a minor or are below the age of 18 years, you
                      shall not register as a User of the Platform and shall not
                      transact on or use the Platform. Any violation will
                      entitle Event Planet to
                      decline/deregister/delete/cancel/suspend such registration
                      or accounts.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* USE OF THE PLATFORM */}
            <div className="content-section">
              <div className="section-header">
                <span className="section-icon">💻</span>
                <h3>USE OF THE PLATFORM</h3>
              </div>

              <div className="platform-role">
                <div className="role-card facilitator">
                  <div className="role-icon">🤝</div>
                  <div className="role-content">
                    <h4>Our Role as Facilitator</h4>
                    <p>
                      Event Planet acts only as a facilitator by providing a
                      Platform where Users can browse, compare, and connect with
                      Service Providers based on pre-designed packages or
                      offerings. Event Planet is not and shall not be a party to
                      any agreement, contract, or arrangement entered into
                      between the User and the Service Provider.
                    </p>
                  </div>
                </div>
              </div>

              <div className="disclaimer-box">
                <div className="disclaimer-header">
                  <span className="disclaimer-icon">⚠️</span>
                  <h5>Important Disclaimer</h5>
                </div>
                <ul className="disclaimer-list">
                  <li>All services are provided solely by Service Providers</li>
                  <li>Event Planet does not control or influence terms</li>
                  <li>Payments are made directly to Service Providers</li>
                  <li>Each transaction is an independent contract</li>
                </ul>
              </div>

              <div className="numbered-list">
                <div className="list-item">
                  <div className="item-number">1</div>
                  <div className="item-content">
                    All event-related services, packages, and offerings listed
                    on the Platform are provided solely by the respective
                    vendors, event managers, venues, or service providers
                    (collectively, "<strong>Service Providers</strong>"). Any
                    terms agreed between the User and the Service Provider,
                    including without limitation, price, applicable taxes,
                    payment terms, date, scope and nature of services,
                    warranties, and other commercial terms, are strictly between
                    the User and the Service Provider.{" "}
                    <span className="highlight-text">
                      Event Planet does not control, determine, or influence
                      such terms in any manner
                    </span>
                    .
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">2</div>
                  <div className="item-content">
                    Event Planet acts only as a facilitator by providing a
                    Platform where Users can browse, compare, and connect with
                    Service Providers based on pre-designed packages or
                    offerings. Event Planet is not and shall not be a party to
                    any agreement, contract, or arrangement entered into between
                    the User and the Service Provider.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">3</div>
                  <div className="item-content">
                    Payments for the services/packages shall be made by the User
                    directly to the respective Service Provider. Event Planet
                    does not collect, process, or hold any payments on behalf of
                    Users or Service Providers.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">4</div>
                  <div className="item-content">
                    Each transaction, booking, or arrangement between the User
                    and the Service Provider shall constitute an independent and
                    binding contract between them, and Event Planet shall bear
                    no responsibility or liability in respect of such
                    transactions, including without limitation performance,
                    quality, delivery, or fulfilment of services.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">5</div>
                  <div className="item-content">
                    Event Planet expressly disclaims any and all liability
                    arising out of or in connection with (i) any deficiency,
                    delay, non-performance, or unsatisfactory quality of
                    services/packages provided by the Service Providers; (ii)
                    any dispute, claim, or disagreement between the User and the
                    Service Provider; (iii) any misrepresentation, fraud,
                    negligence, or misconduct of the Service Provider; or (iv)
                    any loss, damage, cost, or expense suffered by the User as a
                    result of availing services from the Service Provider
                    through the Platform.
                  </div>
                </div>
              </div>
            </div>

            {/* ACCOUNT REGISTRATION */}
            <div className="content-section">
              <div className="section-header">
                <span className="section-icon">👤</span>
                <h3>ACCOUNT REGISTRATION</h3>
              </div>

              <div className="account-guidelines">
                <div className="guideline">
                  <span className="guideline-icon">📱</span>
                  <span>One Account Per User</span>
                </div>
                <div className="guideline">
                  <span className="guideline-icon">🔒</span>
                  <span>Keep Credentials Secure</span>
                </div>
                <div className="guideline">
                  <span className="guideline-icon">📧</span>
                  <span>Accurate Information</span>
                </div>
                <div className="guideline">
                  <span className="guideline-icon">🚨</span>
                  <span>Report Unauthorized Access</span>
                </div>
              </div>

              <div className="numbered-list">
              
                <div className="list-item">
                  <div className="item-number">1</div>
                  <div className="item-content">
                    In order to access and use the Platform, you must register
                    by creating an account ("<strong>Account</strong>") and
                    accepting this Terms of Use. You agree that all information
                    provided by you during registration shall be accurate,
                    current, and complete. The Account shall be used only for
                    your personal use and not for resale, commercial
                    exploitation, or unauthorized purposes.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">2</div>
                  <div className="item-content">
                    We will create your Account based on the information
                    provided by you during registration. Each User is permitted
                    to maintain only <strong>one Account</strong>. Event Planet
                    reserves the right to suspend, merge, terminate, or delete
                    multiple or duplicate Accounts without any liability or
                    obligation to provide compensation.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">3</div>
                  <div className="item-content">
                    We hold right to suspend or terminate Account and your
                    access of the same (i) if any information provided during
                    registration process or thereafter proves to be inaccurate,
                    not current or incomplete (ii) if it is believed that your
                    actions may cause legal liability (iii) if you are found to
                    be non-compliant with the Terms of Use or any other policies
                    and/or (iv) you engage in fraudulent, abusive or unlawful
                    activities.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">4</div>
                  <div className="item-content">
                    Users are responsible for safeguarding the account details
                    and it is agreed that such information shall be not
                    disclosed to third party and that you will take sole
                    responsibility for any activities or actions on Account,
                    whether or not you have authorized such activities or
                    actions. You agree to notify us immediately of any
                    unauthorized access of your Account.
                  </div>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="content-section">
              <div className="section-header">
                <span className="section-icon">📄</span>
                <h3>CONTENT</h3>
              </div>

              <div className="content-types">
                <div className="content-type platform-content">
                  <div className="content-type-icon">🏢</div>
                  <div className="content-type-content">
                    <h5>Platform Content</h5>
                    <p>
                      Owned exclusively by Event Planet. Includes design,
                      layout, graphics, logos, and proprietary information.
                    </p>
                  </div>
                </div>
                <div className="content-type user-content">
                  <div className="content-type-icon">👥</div>
                  <div className="content-type-content">
                    <h5>User Content</h5>
                    <p>
                      Content you upload grants Event Planet a worldwide,
                      royalty-free license to use.
                    </p>
                  </div>
                </div>
              </div>

              <div className="numbered-list">
                <div className="list-item">
                  <div className="item-number">1</div>
                  <div className="item-content">
                    Event Planet is the sole and exclusive owner of all content
                    made available on the Platform, including but not limited to
                    the design, layout, look, appearance, graphics, logos, trade
                    names, trademarks, reviews created by Event Planet,
                    audio-visual material, and other proprietary information
                    (“Platform Content”). Users shall not reproduce, distribute,
                    or disclose any confidential or proprietary information of
                    Event Planet without prior written consent.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">2</div>
                  <div className="item-content">
                    By submitting, posting, or uploading any content (including
                    reviews, photos, videos, comments, or other materials)
                    (“User Content”) on the Platform, you grant Event Planet a
                    worldwide, irrevocable, perpetual, royalty-free,
                    non-exclusive, assignable, sub-licensable, and transferable
                    license to use, reproduce, adapt, publish, translate,
                    distribute, display, and otherwise make such User Content
                    available in connection with the Services.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">3</div>
                  <div className="item-content">
                    You represent and warrant that you are the sole author and
                    owner of the User Content you submit or otherwise have full
                    rights and authority to grant the license described above.
                    You further warrant that your User Content does not infringe
                    the intellectual property rights, privacy rights, or any
                    other rights of any third party.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">4</div>
                  <div className="item-content">
                    You acknowledge and agree that you assume all risks
                    associated with your User Content. Event Planet does not
                    control or pre-screen User Content and does not guarantee
                    its accuracy, integrity, or quality. Event Planet shall not
                    be responsible or liable for any User Content posted on the
                    Platform by User.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">5</div>
                  <div className="item-content">
                    Event Planet reserves the right, at its sole discretion, to
                    remove, disable, or restrict access to any User Content,
                    without notice, for any reason or no reason, including but
                    not limited to Content that violates this Terms of Use or is
                    otherwise objectionable or unlawful.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">6</div>
                  <div className="item-content">
                    While interacting or transacting on the Platform, Users
                    shall not host, display, upload, modify, publish, transmit,
                    store, update, or share any information that violates any
                    applicable law, including the Information Technology Act,
                    2000, the Intermediary Guidelines and Digital Media Ethics
                    Code Rules, 2021, or any other applicable regulations.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">7</div>
                  <div className="item-content">
                    Users shall not upload, post, submit, or transmit any
                    software, code, files, or programs that contain viruses,
                    worms, malware, or other harmful components that may damage,
                    interfere with, or impair the Platform, its services, or any
                    connected network.
                  </div>
                </div>
              </div>
            </div>

           <div className="content-section">
              <div className="section-header">
                <span className="section-icon">💸</span>
                <h3>REFUNDS AND CANCELLATIONS</h3>
              </div>

              <div className="numbered-list">
                <div className="list-item">
                  <div className="item-number">1</div>
                  <div className="item-content">
                    All refund and cancellation requests must be made directly to the Service Provider as per their respective policies and terms.
                  </div>
                </div>
                <div className="list-item">
                  <div className="item-number">2</div>
                  <div className="item-content">
                    Event Planet facilitates communication between Users and Service Providers but does not process or guarantee any refunds.
                  </div>
                </div>
              </div>
            </div>
            <div className="content-section">
              <div className="section-header">
                <span className="section-icon">📄</span>
                <h3>REPRESENTATIONS AND WARRANTIES</h3>
              </div>
              <div className="numbered-list">
                <TCListItem
                  item={[
                    "All information provided by you in connection with registration is true, accurate and legal and you are authorized to share such information. You represent and warrant that information provided by you does not violate any law, notification, order, circular, policy, rules and regulations, is not injurious to any person or is discriminatory with respect to sex, caste, race or religion and/ or property.",
                    "Your use of the Platform shall be strictly personal. No other individual or entity is permitted to use your Account on your behalf. You are solely responsible for all information associated with your Account and for maintaining the confidentiality of your login credentials. You agree to immediately notify Event Planet of any unauthorized use of your Account.",
                    "You shall not submit, upload, post, transmit, or otherwise make available any content that is defamatory, abusive, harassing, insulting, threatening, invasive of privacy, hateful, offensive, obscene, vulgar, violent, unlawful, or otherwise objectionable. You shall further not post content that promotes or incites violence, terrorism, money laundering, gambling, or any activity prohibited under applicable law.",
                    "You represent and warrant that you are the sole owner, license holder, or otherwise have full rights and authority over any intellectual property (including trademarks, copyrights, patents, trade secrets, privacy and publicity rights, and proprietary rights) contained in any content you submit, upload, post, or transmit through the Platform.",
                    "You will not use another person’s username, password or the other account information or impersonate any person or entity or misrepresent your identity or affiliation with any person or entity.",
                    "You represent and warrant that no direction has been issued by any third party or governmental authority which prevents you from accessing the Platform.",
                    "Event Planet disclaims all liability for any content posted by other Users that you may consider offensive, indecent, or objectionable. You agree that your sole remedy is to discontinue use of such content or report it to Event Planet for review.",
                  ]}
                />
              </div>

              <div className="section-header">
                <span className="section-icon">📄</span>
                <h3>OWNERSHIP OF INTELLECTUAL PROPERTY</h3>
              </div>
              <div className="numbered-list">
                <TCListItem
                  item={[
                    "All rights, title, and interest in and to the Platform, including but not limited to the technology, software, source code, object code, design, layout, look and feel, user interface, compilations, text, graphics, logos, trade names, service marks (excluding third-party trademarks, logos and service marks appearing on the Platform), and all intellectual property rights therein (“Platform IP”), are the exclusive property of Event Planet, its affiliates, partners, licensors, or associates.",
                    "Except as expressly permitted under this Terms of Use, Users shall not copy, modify, adapt, translate, create derivative works from, distribute, sell, lease, assign, transfer, reverse engineer, decompile, disassemble, attempt to extract source code from, or otherwise exploit any part of the Platform IP.",
                    "Subject to compliance with this Terms of Use, Event Planet grants Users a limited, non-exclusive, non-transferable, non-sublicensable, revocable license to access and use the Platform solely for personal, non-commercial purposes.",
                    "By submitting or posting any content on the Platform, Users grant Event Planet a worldwide, non-exclusive, royalty-free, perpetual, transferable, and sub-licensable license to use, reproduce, adapt, publish, translate, display, distribute, and make available such content in connection with the Services, in accordance with the User Content clause of this Terms of Use.",
                  ]}
                />
              </div>

              <div className="section-header">
                <span className="section-icon">📄</span>
                <h3>LIMITATION OF LIABILITY</h3>
              </div>
              <div className="numbered-list">
                <TCListItem
                  item={[
                    "Event Planet does not make any representations or warranties with respect to the services offered by third-party vendors, service providers, or event managers (“Service Providers”). Users are advised to independently verify the credentials, suitability, and reliability of any Service Provider before engaging them. Event Planet shall not be responsible for any breach of contract, deficiency in service, delay, or non-performance by the Service Providers.",
                    "The Platform only acts as a facilitator by enabling Users to discover and connect with Service Providers offering event packages. Event Planet does not own, control, manage, or provide the services/packages listed on the Platform. Under no circumstances shall Event Planet hold any right, title, or interest over such services/packages, nor shall Event Planet have any obligations or liabilities in respect of any contract entered into directly between a User and a Service Provider.",
                    "The Service Providers shall be solely responsible and liable for addressing and resolving any User complaints, grievances, or claims relating to the quality, efficiency, suitability, or any other aspect of their services. While Event Planet may, at its discretion, assist in facilitating communication between Users and Service Providers, Event Planet shall not be liable for the outcome of such interactions.",
                    "Event Planet shall not be responsible or liable for any cancellations, rescheduling, delays, non-performance, or failure by any Service Provider to provide services/packages. Event Planet does not guarantee that any transaction, engagement, or arrangement between a User and a Service Provider will be successfully complete.",
                    "Event Planet shall not be responsible for any interruption, delay, or inability to access the Platform or its features arising from technical issues, server downtime, maintenance activities, system upgrades, or any other reasons beyond its reasonable control.",
                    "Event Planet disclaims any responsibility for loss, damage, or harm caused by viruses, malware, or other technologically harmful material that may infect your computer, device, programs, data, or other proprietary material due to the use of the Platform or downloading any material therefrom.",
                  ]}
                />
              </div>

              {/* INDEMNITY */}
              <div className="content-section indemnity-section">
                <div className="section-header">
                  <span className="section-icon">🛡️</span>
                  <h3>INDEMNITY</h3>
                </div>

                <div className="warning-banner">
                  <div className="warning-icon">⚠️</div>
                  <div className="warning-content">
                    <h5>Important Legal Obligation</h5>
                    <p>
                      You are legally responsible for protecting Event Planet
                      from losses caused by your actions
                    </p>
                  </div>
                </div>

                <div className="indemnity-card">
                  <div className="indemnity-header">
                    <div className="indemnity-icon">⚖️</div>
                    <h4>Your Indemnity Commitment</h4>
                  </div>

                  <div className="indemnity-content">
                    <p>
                      The User expressly agrees to defend, indemnify, and hold
                      harmless
                      <span className="highlight-company"> Event Planet</span>,
                      its affiliates, subsidiaries, group entities (present and
                      future), and their respective officers, directors,
                      employees, representatives, agents, successors, and
                      assigns (collectively, the "
                      <span className="highlight-term">
                        Indemnified Parties
                      </span>
                      ") from and against any and all losses, damages,
                      liabilities, claims, demands, actions, suits, costs, and
                      expenses (including reasonable legal fees) arising out of
                      or in connection with:
                    </p>

                    <div className="indemnity-points">
                      <div className="indemnity-point">
                        <div className="point-number">(i)</div>
                        <div className="point-content">
                          <span className="point-title">Breach of Terms</span>
                          <p>
                            any breach by the User of this Terms of Use,
                            including any representations, warranties, or
                            covenants made herein
                          </p>
                        </div>
                      </div>

                      <div className="indemnity-point">
                        <div className="point-number">(ii)</div>
                        <div className="point-content">
                          <span className="point-title">Legal Violations</span>
                          <p>
                            any violation of applicable laws, regulations, or
                            third-party rights by the User
                          </p>
                        </div>
                      </div>

                      <div className="indemnity-point">
                        <div className="point-number">(iii)</div>
                        <div className="point-content">
                          <span className="point-title">
                            Negligence or Misconduct
                          </span>
                          <p>
                            any negligent act, omission, misconduct, or wilful
                            default by the User
                          </p>
                        </div>
                      </div>

                      <div className="indemnity-point">
                        <div className="point-number">(iv)</div>
                        <div className="point-content">
                          <span className="point-title">
                            Intellectual Property Infringement
                          </span>
                          <p>
                            any third-party claim relating to infringement,
                            misappropriation, or violation of intellectual
                            property rights arising from User Content posted,
                            uploaded, or shared on the Platform
                          </p>
                        </div>
                      </div>

                      <div className="indemnity-point">
                        <div className="point-number">(v)</div>
                        <div className="point-content">
                          <span className="point-title">
                            Use of Your Content
                          </span>
                          <p>
                            the use, reproduction, or distribution of User
                            Content by Event Planet, its affiliates, partners,
                            licensors, or associates in accordance with this
                            Terms of Use
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="legal-implications">
                      <div className="implication-card">
                        <div className="implication-icon">💰</div>
                        <div className="implication-content">
                          <h6>Financial Responsibility</h6>
                          <p>
                            You are responsible for all costs, including legal
                            fees
                          </p>
                        </div>
                      </div>
                      <div className="implication-card">
                        <div className="implication-icon">⚔️</div>
                        <div className="implication-content">
                          <h6>Defense Obligation</h6>
                          <p>You must defend Event Planet against claims</p>
                        </div>
                      </div>
                      <div className="implication-card">
                        <div className="implication-icon">🛡️</div>
                        <div className="implication-content">
                          <h6>Protection Duty</h6>
                          <p>You must protect Event Planet from losses</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="indemnity-note">
                  <div className="note-icon">📝</div>
                  <div className="note-content">
                    <p>
                      <strong>Note:</strong> This indemnity clause is a legally
                      binding commitment. You should ensure you understand your
                      obligations before using our Platform. Consider obtaining
                      appropriate insurance if needed.
                    </p>
                  </div>
                </div>
              </div>

              <div className="section-header">
                <span className="section-icon">📄</span>
                <h3>TERM AND TERMINATION</h3>
              </div>
              <div className="numbered-list">
                <p>
                  The Terms of Use, together with any Supplementary Terms,
                  policies, guidelines, code of conduct, or any other rules
                  issued by Event Planet from time to time (collectively
                  “Terms”), shall remain in force unless terminated by either
                  you or Event Planet in the manner set out below.
                </p>
                <TCListItem
                  item={[
                    "A User may terminate this Terms by discontinuing use of the Platform and/or closing their account.",
                  ]}
                />
                <p>
                  Event Planet, in its sole discretion and in addition to any
                  other remedies available under law, may restrict, suspend,
                  deactivate, discontinue, or permanently terminate a User’s
                  access/account on the Platform without prior notice or
                  liability if:
                </p>
                <TCListItem
                  item={[
                    "User is found to be in breach of this Terms as applicable from time to time;",
                    "User has misrepresented facts or information or found to have furnished wrong/incorrect details;",
                    "User conduct is in violation of applicable laws of India;",
                    "User has misbehaved, harassed, or otherwise acts unlawfully towards other Users, Service Providers, partners, or Event Planet representatives;",
                    "Any complaint, report, or allegation of misconduct is received against the User;",
                    "Event Planet reasonably believes that the User’s actions may infringe intellectual property or other third-party rights; or",
                    "Event Planet receives any order/notice from any judicial, quasi-judicial, administrative, regulatory, investigative body to suspend or terminate User’s Account;",
                    "No claims shall be maintainable against Event Planet for any loss or damage that may be caused to the User or any person as a result of any termination, suspension, discontinuation, or deactivation of User’s Account by Event Planet as above said.",
                    "Any suspension of User Account or restriction imposed temporarily will be in the instances where Event Planet may in its sole discretion investigate the default of User and reserves the right to reinstate such Account at additional cost or undertaking to be provided by the User.",
                    "The User acknowledges that Event Planet is merely a facilitator and does not control or process payments between Users and Service Providers. Accordingly, no refund, compensation, or claim shall be entertained by Event Planet in connection with any termination, suspension, or discontinuation of a User account. Any claims for refund (if applicable) shall be raised directly with the concerned Service Provider as per their terms and policies.",
                  ]}
                />
              </div>

              <div className="section-header">
                <span className="section-icon">📄</span>
                <h3>MISCELLANEOUS</h3>
              </div>
              <div className="numbered-list">
                <TCListItem
                  item={[
                    "This Terms of Use including Privacy Policy, Supplementary Terms and policies as applicable to any Services offered by Event Planet constitutes the entire agreement between you and Event Planet with respect to your use of Platform and Services offered by us.",
                    "Terms of this Terms of Use, Privacy Policy, Supplementary Terms and policies as applicable that, by their nature and content, are intended to survive the completion, rescission, termination or expiration of this Terms of Use, shall so survive and continue to bind the Parties for the maximum period of time permitted under applicable law.",
                    "Nothing in this Agreement shall be construed as to create the relationship of employer-employee, partners, collaborators, joint-venture or principal-agent between the parties hereto.",
                    "We treat your information with confidentiality and all your information shared by you with us is governed by our Privacy Policy.",
                    "Any notice in connection with your Services or transactions with us, or as required under applicable laws, shall be effective upon being posted on our Platform or delivered to you at the e-mail ID and/or registered mobile number (including WhatsApp) provided by you at the time of registration. Event Planet shall not be liable if you provide an incorrect or inaccessible email ID or mobile number. Any notice or communication from the User to Event Planet shall be sent in writing to us at:Name: [●], Email: [●], Address: [●]",
                    "In the event of any circumstances or situations beyond our reasonable control including acts of God, labor unrest, insolvency, pandemic, epidemic, business exigencies, government orders, terrorist activity, operational or technical issues, or any other reason that limits our ability to provide Services (“Force Majeure”), Event Planet may suspend, limit, or terminate your access to the Platform with reasonable written notice to your registered e-mail ID and/or mobile number. Event Planet shall take all reasonable measures to mitigate any delay or disruption caused; however, Event Planet shall not be held liable for any consequences resulting from such Force Majeure circumstances.",
                    "The Terms of Use are subject to amendment or modification from time to time. Any such amendments will be updated on the Platform, and continued use of the Platform and Services shall be deemed acceptance of the revised Terms. Users are advised to periodically visit the Platform to review the latest version.",
                    "Event Planet may incorporate any feedback, suggestion, or idea shared by Users into its content, material, or services. User acknowledges and agrees that: (i) Event Planet shall not be obliged to provide any credit or compensation to the User for such incorporation;(ii) no intellectual property rights of the User shall be recognized in such suggestions or feedback; and (iii) Event Planet assumes no confidentiality obligations with respect to such feedback.User expressly waives all claims, including moral rights, in any such feedback or suggestions. ",
                    "If any provision of this Terms of Use is determined to be invalid or unenforceable in whole or in part, such invalidity or unenforceability shall attach only to such provision or part of such provision and the remaining part of such provision and all other provisions of this Terms of Use shall continue to be in full force and effect.",
                    "Failure or delay on part of either Party to enforce any provision(s) of this Terms of Use at any point of time shall not be construed to be a waiver by such Party of such rights thereafter to enforce each and every provision of this Agreement.",
                    "Event Planet may assign or transfer its rights, obligations, benefits, either in whole or in part, without the prior written consent or intimation to the User. User is not entitled to transfer or assign his/her rights, obligations or benefits under this Terms of Use or any Supplementary Agreement or policies governing User’s relationship with us.",
                    "This Terms of Use shall be construed in accordance with the laws of India. Any disputes arising hereunder shall be subject to the exclusive jurisdiction of the competent courts at Lucknow, subject however to applicable consumer protection laws.",
                  ]}
                />
              </div>
              {/* Continue with other sections... */}
              {/* Due to length, I'm showing the structure for remaining sections */}

              {/* Part B International Operations */}
              <div className="section-divider international">
                <h2 className="part-title">
                  PART B - International Operations
                </h2>
                <div className="divider-line"></div>
                <div className="international-badge">🌍 International</div>
              </div>

              {/* International Terms Content */}
              <div className="content-section international-section">
                <div className="section-header">
                  <span className="section-icon">🌐</span>
                  <h3>SCOPE AND APPLICABILITY</h3>
                </div>

                <div className="international-card">
                  <div className="international-icon">⚖️</div>
                  <div className="international-content">
                    <p>
                      These additional terms ("
                      <strong>International Terms</strong>") apply when Event
                      Planet services are accessed, used, or availed by Users
                      located outside India or when services are rendered in
                      international jurisdictions. These terms are supplemental
                      to Part A of the Terms & Conditions. In case of a
                      conflict, these International Terms shall prevail for
                      cross-border transactions.
                    </p>
                  </div>
                </div>

                <div className="section-header">
                  <span className="section-icon">📄</span>
                  <h3>CROSS BORDER PAYMENTS</h3>
                </div>
                <div className="numbered-list">
                  <TCListItem
                    item={[
                      "Event Planet does not collect or hold payments on behalf of User or Service Providers.",
                      "Any international payments are directly settled between User or Service Providers, subject to their mutual arrangements.",
                      "User acknowledge that cross-border payments may be subject to foreign exchange rates, bank charges, withholding taxes, and regulatory requirements. Event Planet bears no responsibility for any such charges, delays, or losses.",
                      "Service Providers shall be responsible for compliance with applicable foreign exchange laws, tax registrations (including GST, VAT, or equivalent), and for providing valid invoices for international Users.",
                      "Where both the User and Service Providers are located in the same foreign jurisdiction, payments shall be governed solely by the local laws and arrangements between them. Event Planet shall have no role or liability in such settlement.",
                    ]}
                  />
                </div>

                <div className="section-header">
                  <span className="section-icon">📄</span>
                  <h3>REFUNDS AND CANCELLATIONS</h3>
                </div>
                <div className="numbered-list">
                  <TCListItem
                    item={[
                      "Event Planet shall not be responsible for processing or guaranteeing refunds in cross-border transactions.",
                      "Refunds, if applicable, shall be governed by Service Provider's individual cancellation and refund policies. However, for international User, the following standard timelines shall apply unless otherwise agreed between the Client and Vendor in writing:",
                      "Cancellation made more than 90 days before the event: 90% refund of the booking amount (after deducting applicable taxes/charges).",
                      "Cancellation between 60 to 90 days before the event: 50% refund of the booking amount (after deducting applicable taxes/charges).",
                      "Cancellation between 30 to 60 days before the event: 25% refund of the booking amount (after deducting applicable taxes/charges).",
                      "Cancellation within 30 days of the event: No refund shall be payable.",
                      "Refunds shall be subject to deductions for applicable local taxes, bank charges, and foreign exchange variations.",
                      "Event Planet disclaims any liability for disputes arising out of refunds, chargebacks, or cancellations across jurisdictions.",
                    ]}
                  />
                </div>

                <div className="section-header">
                  <span className="section-icon">📄</span>
                  <h3>DATA PROTECTION AND PRIVACY</h3>
                </div>
                <div className="numbered-list">
                  <TCListItem
                    item={[
                      "In addition to Indian data protection laws, Event Planet shall comply with applicable international data protection frameworks, including the EU General Data Protection Regulation (GDPR) and similar laws in other jurisdictions where services are rendered.",
                      "Users acknowledge that personal data may be transferred across borders for facilitation of services. By using the Platform internationally, Users consent to such cross-border transfers.",
                      "Service Providers are solely responsible for compliance with local data protection laws applicable in the jurisdictions where they operate.",
                    ]}
                  />
                </div>

                <div className="section-header">
                  <span className="section-icon">📄</span>
                  <h3>REGULATORY AND TRADE COMPLIANCE</h3>
                </div>
                <div className="numbered-list">
                  <TCListItem
                    item={[
                      "Users shall ensure compliance with all local laws, licensing requirements, venue regulations, safety standards, and public gathering laws in the country where the event is organized.",
                      "Services shall not be used in violation of applicable trade sanctions, embargoes, or export control laws.",
                    ]}
                  />
                </div>

                <div className="section-header">
                  <span className="section-icon">📄</span>
                  <h3>LIABILITY DISCLAIMER FOR INTERNATIONAL USE</h3>
                </div>
                <div className="numbered-list">
                  <TCListItem
                    item={[
                      "Event Planet acts only as a facilitator connecting Users and Service Providers across jurisdictions and does not control, supervise, or guarantee the quality, legality, or safety of services provided internationally.",
                      "Event Planet shall not be liable for:",
                      "Foreign exchange losses, banking delays, or international remittance failures;",
                      "Non-performance of Users or Service Providers due to legal restrictions, sanctions, or force majeure events; or",
                      "Any injury, loss, or damage arising during international events, whether direct or incidental.",
                    ]}
                  />
                </div>

                <div className="section-header">
                  <span className="section-icon">📄</span>
                  <h3>GOVERNING LAW AND DISPUTE RESOLUTION</h3>
                </div>
                <div className="numbered-list">
                  <TCListItem
                    item={[
                      "This International Terms shall be governed primarily by the laws of India insofar as they relate to the operations of Event Planet as a facilitator.",
                      "Any disputes involving Event Planet directly shall be subject to arbitration in accordance with the Arbitration and Conciliation Act, 1996, seated in Lucknow, India, in English, and thereafter subject to the exclusive jurisdiction of the courts at Lucknow, India.",
                      "Any disputes between Users and Service Providers arising out of services performed in a foreign jurisdiction (including payments, cancellations, refunds, or quality of services) shall be governed by and subject to the local laws and competent courts/arbitration of that jurisdiction.",
                      "Where mandatory consumer protection or public interest laws of the event’s host country apply, such laws shall prevail for the limited scope of such transactions. ",
                    ]}
                  />
                </div>
              </div>
              {/* Footer */}
              <div className="terms-footer">
                <div className="footer-content">
                  <div className="footer-logo">Event Planet</div>
                  <div className="footer-info">
                    <p>
                      Thank you for choosing Event Planet for your event
                      planning needs.
                    </p>
                  </div>
                  <div className="acceptance-box">
                    <div className="acceptance-icon">✓</div>
                    <div className="acceptance-text">
                      By using our Platform, you acknowledge that you have read,
                      understood, and agree to be bound by these Terms and
                      Conditions.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
        <Footer/>
        </>
    )
}

export default TermCondition